module.exports = __webpack_public_path__ + "img/img5-7.b97e4b2d.png";